import React, { Component } from 'react'
import IntegrationConnector from '../components/IntegrationConnector'
import { APP_URL, WORDPRESS_CLIENT_ID } from 'constants/ResourcesConstants'
import { Input } from '@driftt/tide-core-legacy'
import cx from 'classnames'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setWordpressV2Integration, setWordpressDomain, fetchWordpressDomain } from 'app/modules/integrations/actions'

const WordPressPayload = {
  client_id: WORDPRESS_CLIENT_ID,
  response_type: 'code',
  redirect_uri: `${APP_URL}/accept-integration/wordpress`
}
const WordPressAuthUrl = 'https://public-api.wordpress.com/oauth2/authorize'

class WordPress extends Component {
  componentDidMount() {
    this.props.fetchWordpressDomain()
  }

  setWordpressDomain = value => {
    this.props.setWordpressDomain({ rootUrl: value })
  }

  handleInputChange = e => {
    const value = e.target.value

    this.setWordpressDomain(value)
    this.handleConnect(value)
  }

  handleConnect = value => {
    const payload = value === '' ? {
      integration: 'wordpressV2',
      connected: false
    } : {
      integration: 'wordpressV2',
      connected: true
    }

    this.props.setWordpressV2Integration(payload)
  }

  render() {
    const { rootUrl, hasWordpressIntegrationV1, hasWordpressIntegrationV2 } = this.props
    const errorMessage = 'Error connecting. Please check that you have a valid wordpress URL.'
    const hasNeitherWordpressVersionIntegration = !hasWordpressIntegrationV1 && !hasWordpressIntegrationV2

    return (
      <div>
        <p>Use Drift’s intelligent messaging to answer your visitors questions using
          your Wordpress knowledge base.</p>
        
        {!this.props.isConnected && hasWordpressIntegrationV1 &&
          <div className="connect-container">
            <IntegrationConnector
              integrationId="wordpress"
              isOauth={true}
              oauthLink={WordPressAuthUrl}
              oauthQueryParams={WordPressPayload}
              title="Connect Account"
              connectorType="button"
              buttonType="primary"
              className="wordpress-integration-connector"
            />
          </div>
        }

        {(hasWordpressIntegrationV2 || hasNeitherWordpressVersionIntegration) &&
          <div>
            <div>
              <Input
                placeholder="http://link-to-knowledgebase.com"
                label="Wordpress knowledge base URL:"
                value={rootUrl}
                className={cx('wordpress-input')}
                onChange={this.handleInputChange}
                size="large"
                description={!!this.props.error && <p className="input-error-message">{errorMessage}<a href="https://help.drift.com/article/knowledge-base-and-help-doc-integrations/"> Learn more</a></p>}
              />
            </div>
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    hasWordpressIntegrationV1: state.getIn(['integrations', 'connections']).wordpress,
    hasWordpressIntegrationV2: state.getIn(['integrations', 'connections']).wordpressV2,
    error: state.getIn(['wordpressIntegrationDomain', 'error']),
    rootUrl: state.getIn(['wordpressIntegrationDomain', 'rootUrl'])
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setWordpressV2Integration,
    setWordpressDomain,
    fetchWordpressDomain
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(WordPress)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/WordPress.js